/*
 * @Author: Merlin
 * @Date: 2024-09-12 16:15:57
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-08 15:52:56
 * @Description: 
 */

export enum oLongShort {
    short = "short",
    long = "long",
    none = "", // 默认为此项，用于点亮买涨买跌2个按钮供用户选择 
};

export enum oPnlFlat {
    pnl = "pnl", 
    flat = "flat", 
}

export enum oWavesContractStatus {
    active = "active", // 用户界显示为 ● open  
    cashed = "cashed", 
    busted = "busted", 
    profit = "profit", 
    loss = "loss", 
}

// ↓合约的状态名
export enum WavesContractStateAll{
    active = "active", // 用户界显示为 ● open  
    cashed = "cashed", 
    busted = "busted", 
    profit = "profit", 
    loss = "loss", 
    // ↑ 与 oWavesContractStatus 相同 
    none = "",
    fundingClose = "fundingClose", 
    cashOutProcessing = "cashOutProcessing", 
}

// ↓ 止盈止损相关 
export enum oTriggerType {
    price = 'price', // 通过“点数” 止盈止损 
    value = 'value', // 通过“金额” 止盈止损 
    none = "",
}

// ↓ 4种表格类型 
export enum oTable4Types {
    active = "active",
    closed = "closed",
    public = "public",
    leaderboard = "leaderboard",
}

// ↓ 查询某片波形数据时的参数规格
export interface Par4FuturesTick {
    pair: string; // FuryWaves_USDT, BTC_USDT, ETH_USDT 
    rangeMs: number; // 15000（1秒，5分，4小时...)
    // ↓ 某时间点的 “秒级” 时间戳（不传此值表示取最新时段）  
    // ↓ 通常在切换时间粒度时首次请求不传此值，取到最新一段，然后取得返回值[0] 的时间发起2次请求  
    date?: number;
}

// ↓ 退出游戏时的参数规格 
export interface Par4WavesLeave{
    room: 'publicPositionsRoom' | 'futuresSettings'; 
}

// ↓ 止盈止损设定 
interface WavesPNL {
    stopLossPrice?: String, // 数值，或字符，例如： "0.01" 
    stopLossAmount?: String,
    takeProfitPrice?: String,
    takeProfitAmount?: String,
    selectedTriggerLoss?: oTriggerType, 
    selectedTriggerProfit?: oTriggerType, 
}

// ↓ 用于“建仓” 的请求参数 
export interface WavesPositionCreate extends WavesPNL{
    wager: number, // 也接收字符，例如： "0.01" 
    multi: number, 
    type: oLongShort.long | oLongShort.short, 
    feeType: oPnlFlat, 
    pair: oPairsMap, 
}

// ↓ 平仓“一项” 的请求参数 
export interface WavesPositionCloseOne{
    positionId: String; 
}

// ↓ 已建仓修改
export interface WavesPositionUpdate extends WavesPNL, WavesPositionCloseOne{
    // 无，全部来自继承 
}


// ↓ 查询“大表格” 时提交的参数  
export interface WavesPositionHistory{
    type: oTable4Types,
    perPage: number,
    page: number,
    pair: "" | oPairsMap,
}

// ↓ 所有币
export enum oCoinMap {
    ADA = 'ADA',
    AVAX = 'AVAX',
    BCH = 'BCH',
    BNB = 'BNB',
    BTC = 'BTC',
    DOGE = 'DOGE',
    ETH = 'ETH',
    NOT = 'NOT',
    SOL = 'SOL',
    XRP = 'XRP',
}

// ↓ 所有币对 
export enum oPairsMap {
    ADA_USDT = 'ADA_USDT',
    AVAX_USDT = 'AVAX_USDT',
    BCH_USDT = 'BCH_USDT',
    BNB_USDT = 'BNB_USDT',
    BTC_USDT = 'BTC_USDT',
    DOGE_USDT = 'DOGE_USDT',
    ETH_USDT = 'ETH_USDT',
    NOT_USDT = 'NOT_USDT',
    SOL_USDT = 'SOL_USDT',
    XRP_USDT = 'XRP_USDT',
}

export interface OneTick {
    "time": number;
    "open": number;
    "high": number;
    "low": number;
    "close": number;
    "value"?: number; // 在波形图中会收到此值 
}

export type TikcArr = OneTick[]; 

export interface ResTickData {
    data: TikcArr, 
    error?: string, 
}

interface PnlFee {
    // 金额 档位：计费比例 
    // "1": { "0": 0.1, "1": 0.89, "5": 0.898, "10": 0.8998, "50": 0.8999, "100": 0.89998, "500": 0.89999, "0.01": 0.88, "0.05": 0.88, "0.1": 0.88, "0.5": 0.89 },
    // "1000": { "0": 0.1, "1": 0.8935, "5": 0.8987, "10": 0.89935, "50": 0.89987, "100": 0.899935, "500": 0.899987, "0.01": 0.52, "0.05": 0.786, "0.1": 0.839, "0.5": 0.8872 },
    // "10000": { "0": 0.1, "1": 0.88913, "5": 0.897806, "10": 0.898901, "50": 0.89978, "100": 0.89989, "500": 0.899978, "0.01": 0.405, "0.05": 0.7232, "0.1": 0.802, "0.5": 0.87852 },
    // "100000": { "0": 0.1, "1": 0.8910890911, "5": 0.8955223955, "10": 0.8991008991, "50": 0.8995502296, "100": 0.8999100099, "500": 0.899955002, "0.01": 0.15, "0.05": 0.4325, "0.1": 0.45678, "0.5": 0.8571428571 } 
    [key: string]: {
        // 金额 档位：计费比例  
        [key: string]: number;
    };
}

interface FlatFee { 
    // 金额档位：计费比例 
    [key: string]: number;
    // "1": 0.00035,
    // "33334": 0.00036,
    // "100000": 0.00037,
    // "166667": 0.00038,
    // "233334": 0.00039,
    // "300000": 0.0004,
    // "366667": 0.00041,
    // "433334": 0.00042,
    // "500000": 0.00043,
    // "566667": 0.00044,
    // "633334": 0.00045,
    // "700000": 0.00046,
    // "766667": 0.00047,
    // "833334": 0.00048,
    // "900001": 0.00049,
    // "966667": 0.0005,
}

export interface OnePairsConfig {
    availableFees: {
        pnl: boolean;
        flat: boolean;
    };
    pnlFee: PnlFee;
    flatFee: FlatFee;
    // --- ↑ 计费信息 --------------------------------- 
    maxUserPositionAmount: number;
    weight: number; // 权重，在前端有按此值排序， 
    minWagerAmount: number;
    maxWagerAmount: number;
    minUserPositionAmount: number;
    bustBuffer: number;
    bufferMultiplier: number;
    maxMultiplier: number;
    precision: number;
    endOfFundingPeriod: number;
}

export interface AllPairsConfig {
    [oCoinMap.ADA]: OnePairsConfig,
    [oCoinMap.AVAX]: OnePairsConfig,
    [oCoinMap.BCH]: OnePairsConfig,
    [oCoinMap.BNB]: OnePairsConfig,
    [oCoinMap.BTC]: OnePairsConfig,
    [oCoinMap.DOGE]: OnePairsConfig,
    [oCoinMap.ETH]: OnePairsConfig,
    [oCoinMap.NOT]: OnePairsConfig,
    [oCoinMap.SOL]: OnePairsConfig,
    [oCoinMap.XRP]: OnePairsConfig,
}


export interface ConfirmSetting {
    confirmCashOut: boolean;
    confirmAllCashOut: boolean;
}

interface CommonUserSettings {
    rangeMs: number;
    termsAndConditionsConfirmed: boolean;
    settings: ConfirmSetting;
}

// ↓ 重点配置对象，在进入游戏时先请求此对象，以取得游戏的设定   
export interface WavesSettings {
    pairs: AllPairsConfig;
    commonUserSettings: CommonUserSettings;
    error?: string;
}

export interface WavesStatusColor {
    color: string; 
    colorShallow: string; // 浅色 
    icon: string; 
    icon02: string; 
}

// ↓ 一个合约记录， 
export interface WavesHistory {
    "pair": oPairsMap, // "BTC_USDT" 
    "currency": string, // "usdt" 
    "pairCurrency": string, // "btc" 
    "type": oLongShort, 
    "feeType": oPnlFlat,
    "state": oWavesContractStatus,
    "pnl": number, // 手续费 
    "flatFee"?: number, // 手续费 
    // -- ↑ 信息01: 关键信息 -------------------- 
    "wager": number,
    "multi": number,
    "positionAmount": number, 
    // -- ↑ 信息02: 数值类数据 ----------------------- 
    "takeProfitPrice": number | '', // price = 点数  
    "takeProfitAmount": number | '', // amount = 金额  
    "stopLossPrice": number | '', 
    "stopLossAmount": number | '', 
    "selectedTriggerLoss": oTriggerType,
    "selectedTriggerProfit": oTriggerType,
    // -- ↑ 信息03: 止盈/损设定信息 -----------------------  
    "entryPrice": number,
    "bustPrice": number,
    "exitPrice": number,
    // ----------------------- 
    "_id": number,
    "place"?: number,
    "roi": number,
    "name": string, 
    "closedAt"?: number, // 原版为字符时间，
    "timestamp": number,
    // -- ↓其它 --------------------- 
    "funding": number, // 可为负 
    "avatar": number,
    "validated": boolean, 
    "bold"?: boolean, 
    "userId": number,
}

export interface WavesHistoryPlus extends WavesHistory {
    oTypeColor: WavesStatusColor, // 合约本身的 long/short 颜色 
    oROIColor: WavesStatusColor, // 按输赢结果显示的颜色 1 
    oPNLColor: WavesStatusColor, // 按输赢结果显示的颜色 2 
    precision: number, // 精度（不同币种的价位需要使用不同的小数位数）  
    iDecimalPlaces: number, // 精度（用户下注金额的精度）  
    stateRealtime?: WavesContractStateAll, // 实时合同状态（因为可能突然爆仓了或止损了）
}

export type WavesHistoryList = WavesHistory[]; 
export type WavesHistoryListPlus = WavesHistory[]; 

export interface WavesHistoryData {
    error?: string, 
    data: {
        count?: number, 
        items: WavesHistoryList,
    },
}

